import { render } from "./BasePopup.vue?vue&type=template&id=0cc55dc0&scoped=true"
import script from "./BasePopup.vue?vue&type=script&lang=js"
export * from "./BasePopup.vue?vue&type=script&lang=js"

import "./BasePopup.vue?vue&type=style&index=0&id=0cc55dc0&lang=scss&scoped=true"

import exportComponent from "/megatech/web/znxl/znxl_saas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc55dc0"]])

export default __exports__